import queryString from 'query-string'
import utils from '../../libs/utils'

const parsedQuery = queryString.parse(window.location.search);
const correlationID = parsedQuery.cid;
var validResultParams = ['transactionHash', 'signedTransaction', 'r', 's', 'v', 'signature', 'error', 'walletId'];
window?.opener?.postMessage({ type: 'SIGNER_FINISHED', correlationID: correlationID, result: utils.createResult(validResultParams, window.location.search) }, '*');
export default function PopupTransactionFinish() {
  
  return (
    ""
  );
}